import diplomat from '../assets/images/diplomat.jpg';
import steviemac from '../assets/images/steviemac.png';
import phildalton from '../assets/images/phildalton.jpg';
import farrell from '../assets/images/farrell.jpeg';
import amy from '../assets/images/amy.jpeg';
import chris from '../assets/images/chris.jpg';
import kev from '../assets/images/kev.jpg';
import ger from '../assets/images/ger.jpg';
import paul from '../assets/images/paul.jpg';
import rachel from '../assets/images/rachel.jpg';
import suzy from '../assets/images/suzy.jpg';
import katie from '../assets/images/katie.png';
import nicko from '../assets/images/nicko.jpg';
import steve from '../assets/images/steve1.jpg';
import dom from '../assets/images/dom.jpg';
import PageHeader from '../components/PageHeader';

type Collaborator = {
    name: string
    image: string
    url?: string
    bio: string
}

const collaborators: Collaborator[] = [
    {
        name: 'Steve Ahern',
        image: steve,
        url: 'https://soundcloud.com/hydmusicstuff',
        bio: "When he's not killing it as part of blues rock band Limit 60 he's making wildly underappreciated music under the name HYD. Appears on bass for 'Swine Lake part II'.",
    },
    {
        name: 'Kevin Carlisle',
        image: kev,
        bio: "The noise maker of Master & Dog. A metal head playing indie music. Appears on drums for 'Swine Lake PtII', 'Shelter from the Storm', 'Sun City Poms', 'Sins', 'Animals', 'Sleeves' & 'Wood for the Trees'.",
    },
    {
        name: 'Dominic Coyle',
        image: dom,
        url: 'https://soundcloud.com/pocket-promise',
        bio: "Pavement have Scott Kannberg, Pocket Promise have Dom. An indie guitar wizard, now primarily working in TV & Film but he still appeases the musical side of his personality every now and again. Appears on guitar for 'Sins'.",
    },
    {
        name: 'Suzy Coyle',
        image: suzy,
        url: 'https://soundcloud.com/suitcase-suzy/the-stars-above-1',
        bio: "Suzy not only writes and performs under her own name but with a multitude of other acts. From ballads to out and out rock, she's sung on them all. Appears on backing vox for 'Vomit'.",
    },
    {
        name: "Philip d'Alton",
        image: phildalton,
        url: 'https://philipwattsdalton.bandcamp.com/album/reflections',
        bio: "A member of Master & Dog and long time collaborator. If you do nothing else today, go and listen to 'Just Called'. Maybe one of the greatest songs to come out of NI. Appears on keys and guitar for 'Vomit' as well as some album recording & mastering credits.",
    },
    {
        name: 'Diplomat',
        image: diplomat,
        url: 'https://diplomatmm.bandcamp.com/album/collaboration-one-sound',
        bio: "A true artist. Paint, print & music. Michael Murphy is a wonderful human soul. Appears on bass for 'Sins' and 'Shelter from the Storm', as well as providing the inspiration and parent piece for 'Swine Lake part II'.",
    },
    {
        name: 'John Farrell',
        image: farrell,
        url: 'https://open.spotify.com/artist/1UqIbRzZwsBVLJ6DmJ1iyc',
        bio: "A multi-disciplinary artist hailing from Dublin. Annoyingly good at everything he turns his hand to. Check out 'Mood Music' on his album '2020', you'll not be disappointed. Appears on bass for 'Wood for the Trees'.",
    },
    {
        name: 'Nick Fitzsimons',
        image: nicko,
        bio: "Nick is a poet, drummer and Dungeon Master. A man who previously ran Penny Distribution in Belfast, pushing local acts to new heights in an effort to shine a light on the scene. Keeps rhythm in the live band as well as appearing on drums for 'Avalanche', 'Liar & Thief', 'Swine Lake part II', Compassionate Leave Carnival & 'Vomit'.",
    },
    {
        name: 'Ger Gormley',
        image: ger,
        url: 'https://builtsound.bandcamp.com/album/concrete-dreams-of-sound',
        bio: "A member of Master & Dog that has been releasing electro-acoustic music under the guise of Being Strangers, as well as dabbling in photography and video work. Appears on bass for 'Sun City Poms'.",
    },
    {
        name: 'Stevie Mac',
        image: steviemac,
        url: 'https://steviemac.bandcamp.com/album/be-under-no-illusions',
        bio: "All round music savant Stevie Mac releases music under his own name and the moniker Tripp Mirror. Appears on bass for 'Avalanche' & 'Compassionate Leave Carnival', guitar on 'Sleeves' & 'Animals' and graces the live band with his presence.",
    },
    {
        name: 'Rachel McCarthy',
        image: rachel,
        url: 'https://thedarklingair.bandcamp.com/',
        bio: "When Rachel isn't fronting The Darkling Air with her guitar and vocals she's either photographing something or making some sort of artwork. Appears on backing vocals for 'Vomit'.",
    },
    {
        name: 'Chris McCorry',
        image: chris,
        url: 'https://www.heliopause.co.uk/',
        bio: "It's hard to keep track of the amount of bands Chris lends his talent to. A brilliant guitar player that just knows what's needed in a track. Can usually be found wearing a Moog tshirt. Appears on guitar for 'Shelter for the Storm' & 'Sins'.",
    },
    {
        name: 'Amy McGarrigle',
        image: amy,
        bio: "Founder of Arc Royale, quite possibly Dave's favourite Belfast band. Amy is a fantastic singer/songwriter/musician who plays in the live band. Appears on 'Liar & Thief', 'Vomit', 'Animals', 'Sleeves' & 'Sun City Poms'.",
    },
    {
        name: 'Paul McIver',
        image: paul,
        url: 'https://elasticfurniturelabel.bandcamp.com/album/minor-peace',
        bio: "The master of experimental jangly guitar pop. Paul has always delivered amazingly crafted songs and been extremely kind with his knowledge of the local scene. Appears on guitar and backing vocals for 'Sins' & 'Wood for the Trees'.",
    },
    {
        name: 'Katie Richardson',
        image: katie,
        url: 'https://www.hexhue.com/',
        bio: "Katie is the hardest working musician in Belfast. Her project Hex Hue sees her merging her theatre work with very cool electronic tunes. A wholistic art project. Appears on backing vocals for 'Vomit'.",
    },
]

const Collaborators = () => {
    return (
        <>
            <PageHeader title='Collaborators' kicker='Different personnel, every recording' />
            <section className='band band--flush-top'>
                <div className='container'>
                    <p className='body-lg collab-intro'>
                        Every track on <em>Orphans</em> was cut with a different line-up. These are the people who turned up on the day.
                    </p>
                    <div className='collab-grid'>
                        {collaborators.map((person) => {
                            const card = (
                                <>
                                    <div className='collab__photo'>
                                        <img src={person.image} alt={person.name} loading='lazy' />
                                    </div>
                                    <h2 className='collab__name'>{person.name}</h2>
                                    <p className='collab__bio'>{person.bio}</p>
                                    {person.url && <span className='link-arrow'>Hear more</span>}
                                </>
                            )
                            return person.url
                                ? <a className='collab' key={person.name} href={person.url} target='_blank' rel='noreferrer'>{card}</a>
                                : <article className='collab' key={person.name}>{card}</article>
                        })}
                    </div>
                </div>
            </section>
        </>
    )
}
export default Collaborators
